module.exports = __webpack_public_path__ + "static/media/Restore_Halloween_Logo.8ba5af1f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Restore_Halloween_Logo.svg
// module id = 691
// module chunks = 0